import AccountCircle from "@mui/icons-material/AccountCircle";
import Avatar from "@mui/material/Avatar";
import { get } from "lodash";
import React from "react";
import { connect } from "react-redux";

function UserAvatar({ avatarText, avatarColor, styleDimensions = {} }) {
    const canRenderAvatar = avatarColor && avatarText;
    if (canRenderAvatar) {
        return (
            <Avatar style={{ backgroundColor: avatarColor, ...styleDimensions }}>
                {avatarText.substring ? avatarText.substring(0, 1) : avatarText}
            </Avatar>
        );
    } else return <AccountCircle />;
}
export default connect((state) => {
    return {
        avatarText: get(state.login.user, "avatarText", null),
        avatarColor: get(state.login.user, "avatarColor", null),
    };
})(UserAvatar);
